(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dimensions-poids_2"] && !Shopify.designMode) return;
  try {
    (function () {
  var KEY = 'dj_dims_unit';

  function init(block) {
    if (block.dataset.dimsReady) return;
    block.dataset.dimsReady = '1';
    var buttons = block.querySelectorAll('[data-set-unit]');

    function setUnit(unit, persist) {
      block.dataset.unit = unit;
      buttons.forEach(function (b) {
        var active = b.dataset.setUnit === unit;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (persist) { try { localStorage.setItem(KEY, unit); } catch (e) {} }
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () { setUnit(b.dataset.setUnit, true); });
    });

    try {
      var saved = localStorage.getItem(KEY);
      if (saved === 'in' || saved === 'cm') setUnit(saved, false);
    } catch (e) {}
  }

  function boot() { document.querySelectorAll('.dj-dims').forEach(init); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
  } catch(e) { console.error(e); }
})();

})();
